export default {
	newsArticleTemplateId: "e84cc91e-bcf9-4695-a0b8-a9dc20b0a9f4"
}